var map = {
	"./acsi.json": 1505,
	"./de-de.json": 1506,
	"./en-us.json": 658,
	"./id.json": 1507,
	"./ja.json": 1508,
	"./ko.json": 1509,
	"./vi.json": 1510,
	"./whitelists/whitelist_acsi.json": 1511,
	"./whitelists/whitelist_de-de.json": 1512,
	"./whitelists/whitelist_en-us.json": 1513,
	"./whitelists/whitelist_en.json": 1514,
	"./whitelists/whitelist_id.json": 1515,
	"./whitelists/whitelist_ja.json": 1516,
	"./whitelists/whitelist_ko.json": 1517,
	"./whitelists/whitelist_vi.json": 1518,
	"./whitelists/whitelist_zh-cn.json": 1519,
	"./whitelists/whitelist_zh-tw.json": 1520,
	"./zh-cn.json": 1521,
	"./zh-tw.json": 1522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1504;